export const getPageSizes = () => {
    return [
        { key: 10, value: 10 },
        { key: 25, value: 25 },
        { key: 50, value: 50 },
    ];
};
